import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query GetPaymentLink($signupId: ID!, $method: SignUpPaymentMethodType!) {
    getPaymentLink(signupId: $signupId, method: $method) {
      key
      signature
      tenantId
      token
      uri
      pageId
    }
  }
`

export const getPaymentLinkKey = getQueryNames(query)[0]
export default query
